import { JobSalary } from '../models/jobSalary';
import * as RequisitionCardActionModal from 'raw-loader!src/app/public/app/partials/missioncontrol/requisitions/requisitionCard/requisition-card-actions-modal.html';
import * as RequisitionBackwardActionModal from 'raw-loader!src/app/public/app/partials/missioncontrol/requisitions/requisitionCard/requisition-backward-action-modal.html';
import * as RequisitionActivityModal from 'raw-loader!src/app/public/app/partials/missioncontrol/requisitions/requisition-activity-modal.html';
import * as RequisitionActionModal from 'raw-loader!src/app/public/app/partials/missioncontrol/requisitions/requisitionCard/requisition-action-modal.html';
import { FormalizeCompany, FormalizeRequisition, FormalizeJobMatch } from 'src/app/public/app/models/formalizePayload';
export class RequisitionService {
    /*@ngInject*/
    constructor($httpParamSerializerJQLike, $rootScope, $uibModal, $timeout, $http, StorageService, genericService, companyService, jobService, jobMatchService, alertsAndNotificationsService, MESSAGECONSTANTS, REQUISITIONSCONSTANTS) {
        this.$httpParamSerializerJQLike = $httpParamSerializerJQLike;
        this.$rootScope = $rootScope;
        this.$uibModal = $uibModal;
        this.$timeout = $timeout;
        this.$http = $http;
        this.StorageService = StorageService;
        this.genericService = genericService;
        this.jobService = jobService;
        this.jobMatchService = jobMatchService;
        this.companyService = companyService;
        this.alertsAndNotificationsService = alertsAndNotificationsService;
        this.MESSAGECONSTANTS = MESSAGECONSTANTS;
        this.REQUISITIONSCONSTANTS = REQUISITIONSCONSTANTS;
        this.urlConstants = {
            GET_ALL_CLIENT_OR_BU: 'api/requisition/getclientorbulist',
            UPLOAD_REQUISITION: 'api/requisition/uploadrequisitiondoc',
            GET_REQUISITION_ACTIVITY: 'api/requisition/requisitionActivity',
            JOB_BOARD_ADVANCED_SEARCH: 'http://jbws-az-4dot5.daxtra.com/jwb/dispatch',
            GET_REQUISITION_DOCUMENT: 'api/requisition/getrequisitionfile',
            GET_VENDOR_RECRUITERS: 'api/user/vendor/recruiters',
            ASSIGN_VENDOR_RECRUITERS: 'api/job/assign/vendor/recruiters',
            GET_ASSIGNED_VENDOR_RECRUITERS: 'api/user/sharedrequisition/vendor/recruiters'
        };
    }
    getAllClientsOrBu(userDetails, requisitionId, isFromCreateReq, successCallback, errorCallback) {
        let url = this.StorageService.get('baseurl') + this.urlConstants.GET_ALL_CLIENT_OR_BU + '/' + userDetails.id + '/' + userDetails.company.companyId;
        if (!_.isNull(requisitionId)) {
            url = url + '?requisitionId=' + requisitionId;
            if (isFromCreateReq) {
                url = url + '&isFromCreateReq=true';
            }
        }
        else if (isFromCreateReq) {
            url = url + '?isFromCreateReq=true';
        }
        this.genericService.getObjects(url).subscribe((data) => {
            successCallback(data.body);
        }, (error) => {
            errorCallback(error);
        });
    }
    getUploadUrl() {
        return this.StorageService.get('baseurl') + this.urlConstants.UPLOAD_REQUISITION;
    }
    getRequisitionActivity(jobId, page, size, successCallback, errorCallback) {
        if (_.isNull(page) || _.isUndefined(page)) {
            page = 1;
        }
        if (_.isNull(size) || _.isUndefined(size)) {
            size = 10;
        }
        let url = this.urlConstants.GET_REQUISITION_ACTIVITY + '/' + jobId + '?page=' + page + '&size=' + size + '&companyId=' + this.$rootScope.userDetails.company.companyId;
        this.genericService.addObject(this.StorageService.get('baseurl') + url).subscribe((data) => {
            successCallback(data.body);
        }, (error) => {
            errorCallback(error);
        });
    }
    getJobBoardsAdvancedSearchInterface(searchObject, successCallback, errorCallback) {
        searchObject = {
            action: "search_interface",
            db: "jw_fourdotfive",
            codes: "IND",
            js_lib: "jquery",
            ajax_updater: "/jb/advancedsearch/updater",
            ajax_auto_completer: "/jb/advancedsearch/autoCompleter",
            libs: "jquery,jquery-ui,jb_params_jq,css"
        };
        let additionalParams = {
            "headers": {
                "Content-Type": "application/x-www-form-urlencoded"
            }
        };
        this.genericService.addObject(this.urlConstants.JOB_BOARD_ADVANCED_SEARCH, this.$httpParamSerializerJQLike(searchObject), additionalParams).subscribe((data) => {
            successCallback(data.body);
        }, (error) => {
            errorCallback(error);
        });
    }
    getRequisitionDocumentUrl(requisitionId) {
        return this.StorageService.get('baseurl') + this.urlConstants.GET_REQUISITION_DOCUMENT + '/' + requisitionId;
    }
    getVendorRecruiters(vendorId, requisitionId, successCallback, errorCallback) {
        let searchObject = {};
        searchObject.vendorId = vendorId;
        searchObject.requisitionId = requisitionId;
        this.genericService.addObject(this.urlConstants.GET_VENDOR_RECRUITERS, searchObject).subscribe((data) => {
            successCallback(data.body);
        }, (error) => {
            errorCallback(error);
        });
    }
    assignRecruiters(assignRecruitersObject, successCallback, errorCallback) {
        this.genericService.addObject(this.urlConstants.ASSIGN_VENDOR_RECRUITERS, assignRecruitersObject).subscribe((data) => {
            successCallback(data.body);
        }, (error) => {
            errorCallback(error);
        });
    }
    getAssignedVendorRecruiters(requisitionId, vendorId, successCallback, errorCallback) {
        this.genericService.getObjects(this.StorageService.get('baseurl') + this.urlConstants.GET_ASSIGNED_VENDOR_RECRUITERS + '/' + requisitionId + '/' + vendorId).subscribe((data) => {
            successCallback(data.body);
        }, (error) => {
            errorCallback(error);
        });
    }
    //common methods for requisition
    massageRequisitionCardInfo(data, salaryDurationOptions) {
        let response = {
            recruitersCount: 0
        };
        if (!data.recruiters) {
            data.recruiters = [];
        }
        if (!data.corporateRecruiters) {
            data.corporateRecruiters = [];
        }
        if (!data.vendorRecruiters) {
            data.vendorRecruiters = [];
        }
        let vendorRecruitersTemp = [];
        angular.forEach(data.vendorRecruiters, (recruiter, key) => {
            let vendorRecruiter = {};
            vendorRecruiter.name = recruiter;
            vendorRecruiter.isPoc = false;
            vendorRecruiter.isVendor = true;
            vendorRecruitersTemp.push(vendorRecruiter);
        });
        if (this.companyService.isCorporateCompany()) {
            data.recruiters = angular.copy(data.corporateRecruiters);
        }
        else {
            data.recruiters = angular.copy(vendorRecruitersTemp);
        }
        response.recruitersCount = data.recruiters.length > 0 ? data.recruiters.length - 1 : null;
        data.allRecruitersList = [...data.recruiters];
        //poc recruiter
        if (data.recruiters.length > 0) {
            response.pocRecruiter = data.recruiters.filter((recruiter) => {
                return recruiter.isPoc == true;
            })[0];
            if (response.pocRecruiter == undefined) {
                response.pocRecruiter = data.recruiters[0];
            }
            _.remove(data.recruiters, {
                name: response.pocRecruiter.name
            });
        }
        data.hiringManagerDetails = data.corporateHiringManagers ? angular.copy(data.corporateHiringManagers) : null;
        // this.recruitersCount = data.corporateRecruiters.length + data.vendorRecruiters.length - 1;
        if (!_.isNull(data.hiringManagerDetails)) {
            if (data.hiringManagerDetails.length > 0) {
                response.primaryHiringManager = data.hiringManagerDetails.filter((manager) => {
                    return manager.isPrimary == true;
                })[0];
            }
        }
        if (_.isNull(data.jobSalaryDto)) {
            data.jobSalaryDto = new JobSalary();
        }
        data.salaryLabel = "Salary Details";
        if (data.jobType == 'Contractor' || data.jobType == 'Contract to Hire') {
            data.salaryLabel = this.companyService.isCorporateCompany() || data.sharedRequisition ? "Bill Rate" : "Client/Bill Rate";
        }
        data.requisitionSalaryDisplayMessage = this._getSalaryDetailsDisplayMessage(data.jobSalaryDto, salaryDurationOptions);
        if (_.isNull(data.sponsorshipProvided) || _.isUndefined(data.sponsorshipProvided)) {
            data.sponsorshipsDisplayMessage = "Sponsorship information not specified";
        }
        else if (_.isNull(data.sponsorships) || data.sponsorships.length == 0) {
            data.sponsorshipsDisplayMessage = "Not Available";
        }
        else if (data.sponsorships.length > 0) {
            data.sponsorshipsDisplayMessage = "";
            let message = "";
            angular.forEach(data.sponsorships, (sponsor, key) => {
                if (key == data.sponsorships.length - 1) {
                    message = message + sponsor;
                }
                else if (key == data.sponsorships.length - 2) {
                    message = message + sponsor + " and ";
                }
                else {
                    message = message + sponsor + ", ";
                }
            });
            data.sponsorshipsDisplayMessage = message;
        }
        data.locationLabel = null;
        data.companyLabel = null;
        data.companyLocationLabel = null;
        if (this.companyService.isCorporateCompany()) {
            // if it is a corporate company
            if (!data.sharedRequisition && !_.isNull(data.clientName)) {
                // show BU name, if it exists
                data.companyLabel = data.clientName;
            }
            else if (data.sharedRequisition && !_.isNull(data.corporateBU)) {
                // show BU name, if it exists
                data.companyLabel = data.corporateBU;
            }
        }
        else {
            // if it is staffing/vendor company
            if (data.sharedRequisition || data.hasSharedCorporateOrBUClient) {
                // if it is shared requisition, show the corporation's name
                data.companyLabel = data.corporateName;
            }
            else {
                // it is not a shared requisition, show the client's name
                data.companyLabel = data.clientName;
            }
        }
        data.companyLocationLabel = _.isNull(data.companyLabel) ? '' : data.companyLabel;
        if (!_.isNull(data.location)) {
            if (!_.isNull(data.location.city) && !_.isNull(data.location.city.name)) {
                data.locationLabel = data.location.city.name;
            }
            if (!_.isNull(data.location.state)) {
                data.locationLabel = _.isNull(data.locationLabel) ? data.location.state : data.locationLabel + ', ' + data.location.state;
            }
        }
        data.companyLocationLabel = _.isNull(data.locationLabel) ? data.companyLocationLabel : data.companyLocationLabel + ' @ ' + data.locationLabel;
        if (!_.isNull(data.sharedClientBuName)) {
            data.companyLocationLabel = data.sharedClientBuName + " @" + data.companyLocationLabel;
        }
        if (data.workflowSteps) {
            this._removeReleasedAndUnInterestedSteps(data.workflowSteps);
        }
        data.noOfOpenings = data.requisitionOpeningsCount ? data.requisitionOpeningsCount.noOfOpenings : null;
        data.noOfFilled = data.requisitionOpeningsCount ? data.requisitionOpeningsCount.noOfFilled : null;
        data.noOfJoined = data.requisitionOpeningsCount ? data.requisitionOpeningsCount.noOfJoined : null;
        data.pocRecruiter = response.pocRecruiter ? response.pocRecruiter : null;
        data.recruitersCount = response.recruitersCount ? response.recruitersCount : null;
        data.primaryHiringManager = response.primaryHiringManager ? response.primaryHiringManager : null;
        response.data = data;
        return response;
    }
    _getSalaryDetailsDisplayMessage(salary, salaryDurationOptions) {
        let message = "";
        if (_.isNull(salary.salaryType)) {
            message = message + "Not Available";
        }
        else if (salary.salaryType == "SPECIFIC") {
            message = message + salary.maxSalary + " " + salary.currency + " " + this._getUOM(salary.salaryDuration, salaryDurationOptions);
        }
        else if (salary.salaryType == "RANGE") {
            message = message + salary.minSalary + " to " + salary.maxSalary + " " + salary.currency + " " + this._getUOM(salary.salaryDuration, salaryDurationOptions);
        }
        return message;
    }
    _getUOM(salaryDuration, salaryDurationOptions) {
        let uom = _.find(salaryDurationOptions, { 'value': salaryDuration });
        if (!angular.isDefined(uom)) {
            uom = "Per Month";
        }
        return uom.name;
    }
    _removeReleasedAndUnInterestedSteps(workflowSteps) {
        workflowSteps.splice(workflowSteps.length - 2, 2);
    }
    //Requisition card actions
    performAction(action, requisitionInfo, refreshCardCallback) {
        let vm = this;
        let windowTopClass = '';
        let modalHeading = '';
        let formalizeActivityPayload = {
            candidate: null,
            requisition: new FormalizeRequisition(requisitionInfo.requisitionNumber, requisitionInfo.requisitionActualNumber, requisitionInfo.requisitionRole),
            jobMatch: new FormalizeJobMatch(requisitionInfo.jobMatchId, requisitionInfo.requisitionNumber, requisitionInfo.requisitionActualNumber, requisitionInfo.requisitionRole),
            company: new FormalizeCompany(requisitionInfo.companyId, requisitionInfo.companyName, requisitionInfo.clientOrBuId, requisitionInfo.clientName)
        };
        switch (action) {
            case 'jobProfile':
                modalHeading = "Job Profile";
                windowTopClass = 'four-dot-five-modal-large';
                break;
            case 'jobLeft':
                modalHeading = "Job Left";
                windowTopClass = 'four-dot-five-modal-medium';
                break;
            case 'doNotHire':
                modalHeading = "Do Not Hire";
                windowTopClass = 'four-dot-five-modal-medium';
                break;
            case 'clientReview':
                modalHeading = "Client Review";
                windowTopClass = 'four-dot-five-modal-large';
                break;
        }
        this.$uibModal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            template: RequisitionCardActionModal.default,
            backdrop: 'static',
            controller: ['$uibModalInstance', 'action', 'jobId', 'clientId', 'clientName', 'modalHeading', 'nonJoinedCandidates', 'formalizeActivityPayload',
                function ($uibModalInstance, action, jobId, clientId, clientName, modalHeading, nonJoinedCandidates, formalizeActivityPayload) {
                    let ctrl = this;
                    ctrl.action = action;
                    ctrl.jobId = jobId;
                    ctrl.clientId = clientId;
                    ctrl.clientName = clientName;
                    ctrl.modalHeading = modalHeading;
                    ctrl.nonJoinedCandidates = nonJoinedCandidates;
                    ctrl.formalizeActivityPayload = formalizeActivityPayload;
                    ctrl.saveCallback = () => {
                        $uibModalInstance.dismiss('cancel');
                        if (refreshCardCallback) {
                            refreshCardCallback();
                        }
                    };
                    this.closeModal = () => {
                        $uibModalInstance.dismiss('cancel');
                    };
                }],
            controllerAs: 'reqCardActionsModal',
            size: 'lg',
            windowTopClass: windowTopClass,
            resolve: {
                jobId: () => {
                    return requisitionInfo.requisitionNumber;
                },
                clientId: () => {
                    requisitionInfo.clientOrBuId;
                },
                clientName: () => {
                    return requisitionInfo.clientName;
                },
                action: () => {
                    return action;
                },
                modalHeading: () => {
                    return modalHeading;
                },
                nonJoinedCandidates: () => {
                    return requisitionInfo.nonJoinedCandidates;
                },
                formalizeActivityPayload: () => {
                    return formalizeActivityPayload;
                }
            }
        });
    }
    performRequisitionAction(stateName, requisitionObject, companyId, copyCallback, deleteCallback, refreshCardCallback) {
        // this.isCandidateFilled = true;
        let requisitionSPOC = {};
        requisitionSPOC.time = '';
        requisitionSPOC.requisitionStatus = requisitionObject.requisitionStatus;
        requisitionSPOC.RequisitionId = requisitionObject.requisitionNumber;
        requisitionSPOC.Role = requisitionObject.requisitionRole;
        requisitionSPOC.noOfOpenings = requisitionObject.noOfOpenings;
        requisitionSPOC.noOfFilledOpenings = requisitionObject.noOfFilledOpenings;
        requisitionSPOC.noOfJustFilledOpenings = requisitionObject.noOfJustFilledOpenings;
        requisitionSPOC.Company = requisitionObject.companyName;
        this._setAndUpdateRequisitionSPOCDateTime(requisitionSPOC);
        requisitionSPOC.activeCandidateCount = requisitionObject.activeCandidateCount;
        requisitionSPOC.passiveCandidateCount = requisitionObject.passiveCandidateCount;
        requisitionSPOC.requisitionActualNumber = requisitionObject.requisitionActualNumber;
        let requisitionFlag = false;
        if (stateName === "Make a Copy") {
            requisitionSPOC.titleName = stateName;
            requisitionSPOC.currentStateName = 'Copy';
        }
        else if ((requisitionObject.requisitionStatus === "FILLED" || requisitionObject.requisitionStatus === "Filled") && stateName === "Stop Sourcing") {
            requisitionSPOC.titleName = "Fill to Sourced";
            requisitionSPOC.currentStateName = stateName;
        }
        else if (stateName === "Remove Filled Candidate") {
            requisitionSPOC.titleName = "Remove Filled Candidate";
            requisitionSPOC.currentStateName = "Stop Sourcing";
        }
        else if ((requisitionObject.requisitionStatus === "COMPLETED" || requisitionObject.requisitionStatus === "Completed") && stateName === "Join") {
            requisitionSPOC.titleName = "Completed to Joined";
            requisitionSPOC.currentStateName = stateName;
        }
        else if (stateName === "Remove Joined Candidate") {
            requisitionSPOC.titleName = "Remove Joined Candidate";
            requisitionSPOC.currentStateName = "Fill";
        }
        else if ((angular.lowercase(requisitionObject.requisitionStatus) === "joined" || angular.lowercase(requisitionObject.requisitionStatus) === "filled") && stateName === "Remove Joined Candidate") {
            requisitionSPOC.titleName = "Remove Joined Candidate";
            requisitionSPOC.currentStateName = "Fill";
        }
        else if (requisitionObject.requisitionStatus === "Canceled" && stateName === "Continue") {
            requisitionFlag = true;
            requisitionSPOC.titleName = "Reopen";
            requisitionSPOC.currentStateName = "Reopen";
        }
        else if (requisitionObject.requisitionStatus === "Sourced" && stateName === "Continue") {
            requisitionSPOC.titleName = "Resume Sourcing";
            requisitionSPOC.currentStateName = "Resume Sourcing";
        }
        else {
            requisitionFlag = true;
            requisitionSPOC.currentStateName = stateName;
        }
        // set default notes
        if (stateName === "Open") {
            requisitionSPOC.note = "Opening Requisition";
        }
        else if (stateName === "Stop Sourcing") {
            requisitionSPOC.note = "Stop Sourcing the Requisition";
        }
        else if (stateName === "Continue" && requisitionSPOC.currentStateName == "Resume Sourcing") {
            requisitionSPOC.note = "Resume Sourcing the Requistion";
        }
        else if (stateName === "Continue") {
            requisitionSPOC.note = "Continuing Requisition";
        }
        else if (stateName === "Fill") {
            requisitionSPOC.note = "Filling Candidate";
        }
        else if (stateName === "Join") {
            requisitionSPOC.note = "Joining Candidate";
        }
        else if (stateName == "Make a Copy") {
            requisitionSPOC.note = "Make a Copy";
        }
        if (requisitionFlag) {
            this.$http.get("api/job/getcandidatesforreqstatus/" + requisitionObject.requisitionNumber + "/" + stateName + "?companyId=" + companyId).success((data) => {
                let candidatesInLastStep = [];
                let candidates = angular.copy(data.candidates);
                candidatesInLastStep = angular.copy(data.candidatesInLastStepToFill);
                if (candidates.length === 0) {
                    candidates = [];
                }
                if (candidatesInLastStep.length == 0) {
                    candidatesInLastStep = [];
                }
                requisitionSPOC.requisitionOpeningNumber = data.requisitionOpeningNumber;
                if (stateName === "Fill" && candidatesInLastStep.length === 0) {
                    this._showAlert('No candidates are available to Fill.');
                }
                else if (stateName === "Join" && candidates.length === 0) {
                    this._showAlert('No candidates are available to Join.');
                }
                else {
                    if (candidates != null && candidates.length > 0) {
                        for (let i = 0; i < candidates.length; i++) {
                            if (candidates[i].lastName != null) {
                                candidates[i].name = candidates[i].firstName + " " + candidates[i].lastName;
                            }
                            else {
                                candidates[i].name = candidates[i].firstName;
                            }
                        }
                    }
                    if (candidatesInLastStep != null && candidatesInLastStep.length > 0) {
                        for (let i = 0; i < candidatesInLastStep.length; i++) {
                            if (candidatesInLastStep[i].lastName != null) {
                                candidatesInLastStep[i].name = candidatesInLastStep[i].firstName + " " + candidatesInLastStep[i].lastName;
                            }
                            else {
                                candidatesInLastStep[i].name = candidatesInLastStep[i].firstName;
                            }
                        }
                    }
                    this._massageJobMatchDetails(candidates, candidatesInLastStep);
                    this._showActionModal(requisitionSPOC, requisitionObject, candidates, candidatesInLastStep, copyCallback, deleteCallback, refreshCardCallback);
                }
            }, (response) => {
                candidates = [];
            });
        }
        else if (stateName == "Make a Copy") {
            this._showActionModal(requisitionSPOC, requisitionObject, [], [], copyCallback, deleteCallback, refreshCardCallback);
        }
        else {
            this.$http.get("api/job/getcandidatesforcurrentstatus/" + requisitionObject.requisitionNumber + "/" + requisitionSPOC.currentStateName + "?companyId=" + companyId).success((data) => {
                let candidates = data;
                if (candidates != null && candidates.length > 0) {
                    for (let i = 0; i < candidates.length; i++) {
                        if (requisitionSPOC.currentStateName === "Stop Sourcing") {
                            if (candidates[i].fillCandidate.contact.lastname != null) {
                                candidates[i].name = candidates[i].fillCandidate.contact.firstname + " " + candidates[i].fillCandidate.contact.lastname;
                            }
                            else {
                                candidates[i].name = candidates[i].fillCandidate.contact.firstname;
                            }
                        }
                        else if (requisitionSPOC.currentStateName === "Fill") {
                            if (candidates[i].joinCandidate.contact.lastname != null) {
                                candidates[i].name = candidates[i].joinCandidate.contact.firstname + " " + candidates[i].joinCandidate.contact.lastname;
                            }
                            else {
                                candidates[i].name = candidates[i].joinCandidate.contact.firstname;
                            }
                        }
                    }
                }
                if (angular.lowercase(requisitionObject.requisitionStatus) === "filled" && stateName === "Stop Sourcing" && candidates.length === 0) {
                    this._showAlert('No candidates are available in Filled state to remove');
                }
                else if (angular.lowercase(requisitionObject.requisitionStatus) === "sourced" && stateName === "Remove Filled Candidate" && candidates.length === 0) {
                    this._showAlert('No candidates are available in Filled state to remove');
                }
                else if ((angular.lowercase(requisitionObject.requisitionStatus) === "completed" || angular.lowercase(requisitionObject.requisitionStatus) === "joined") && stateName === "Fill" && candidates.length === 0) {
                    this._showAlert('No candidates are available in Joined state to remove');
                }
                else if (angular.lowercase(requisitionObject.requisitionStatus) === "filled" && stateName === "Remove Joined Candidate" && candidates.length === 0) {
                    this._showAlert('No candidates are available in Joined state to remove');
                }
                else if (requisitionSPOC.titleName === this.MESSAGECONSTANTS.VIEW_REQUISITION.REMOVE_FILLED_CANDIDATE || requisitionSPOC.titleName === this.MESSAGECONSTANTS.VIEW_REQUISITION.REMOVE_JOINED_CANDIDATE) {
                    let stepName = requisitionSPOC.titleName === this.MESSAGECONSTANTS.VIEW_REQUISITION.REMOVE_FILLED_CANDIDATE ? 'REMOVE_FILL' : 'REMOVE_JOIN';
                    let steps = [stepName];
                    this.jobMatchService.getReasonCodes(steps, (data) => {
                        let stepKey = stepName == 'REMOVE_FILL' ? 'Remove Fill' : 'Remove Join';
                        this.reasonCodes = data[stepKey];
                        this.showBackwardActionModal(requisitionObject, requisitionSPOC, candidates, refreshCardCallback);
                    }, (error) => {
                        this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                    });
                }
                else {
                    this.showBackwardActionModal(requisitionObject, requisitionSPOC, candidates, refreshCardCallback);
                }
            }, (response) => {
                candidates = [];
            });
        }
    }
    _setAndUpdateRequisitionSPOCDateTime(requisitionSPOC) {
        requisitionSPOC.date = moment().format('ll');
        requisitionSPOC.time = moment().format('hh:mm:ss a');
        this.$timeout(() => {
            this._setAndUpdateRequisitionSPOCDateTime(requisitionSPOC);
        }, 1000);
    }
    _showAlert(message) {
        bootbox.alert({
            closeButton: false,
            title: '<div class="alert alert-danger" ><i class="fa fa-times-circle fa-fw fa-lg"></i><strong>Oh snap!</strong></div>',
            message: message
        });
    }
    _massageJobMatchDetails(candidates, candidatesInLastStep) {
        candidates.forEach(candidate => {
            candidate.candidateOtherJobMatchDetail.forEach(jobMatch => {
                let i = 0;
                let recruitersMessage = "";
                jobMatch.recruiterNames.forEach(name => {
                    if (i == jobMatch.recruiterNames.length - 1) {
                        recruitersMessage = `${recruitersMessage} ${name}`;
                    }
                    else if (i == jobMatch.recruiterNames.length - 2) {
                        recruitersMessage = `${recruitersMessage} ${name} and `;
                    }
                    else {
                        recruitersMessage = `${recruitersMessage} ${name}, `;
                    }
                    i++;
                });
                jobMatch.recruitersMessage = recruitersMessage;
            });
        });
        candidatesInLastStep.forEach(candidate => {
            if (candidate.candidateOtherJobMatchDetail !== null) {
                candidate.candidateOtherJobMatchDetail.forEach(jobMatch => {
                    let i = 0;
                    let recruitersMessage = "";
                    jobMatch.recruiterNames.forEach(name => {
                        if (i == jobMatch.recruiterNames.length - 1) {
                            recruitersMessage = `${recruitersMessage} ${name}`;
                        }
                        else if (i == jobMatch.recruiterNames.length - 2) {
                            recruitersMessage = `${recruitersMessage} ${name} and `;
                        }
                        else {
                            recruitersMessage = `${recruitersMessage} ${name}, `;
                        }
                        i++;
                    });
                    jobMatch.recruitersMessage = recruitersMessage;
                });
            }
        });
    }
    _showActionModal(requisitionSPOC, requisitionInfo, candidates, candidatesInLastStep, copyCallback, deleteCallback, refreshCardCallback) {
        let vm = this;
        this.$uibModal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            template: RequisitionActionModal.default,
            windowTopClass: 'four-dot-five-modal-large',
            controller: ['$uibModalInstance', 'requisitionSPOC', 'MESSAGECONSTANTS', 'candidates', 'candidatesInLastStep', 'isSharedRequisition', 'formalizeActivityPayload',
                function ($uibModalInstance, requisitionSPOC, MESSAGECONSTANTS, candidates, candidatesInLastStep, isSharedRequisition, formalizeActivityPayload) {
                    let ctrl = this;
                    ctrl.requisitionSPOC = requisitionSPOC;
                    ctrl.MESSAGECONSTANTS = MESSAGECONSTANTS;
                    ctrl.candidates = candidates;
                    ctrl.candidatesInLastStep = candidatesInLastStep;
                    ctrl.isDeleteInProgress = false;
                    ctrl.isSharedRequisition = isSharedRequisition;
                    ctrl.externalNotesAction = {};
                    ctrl.formalizeActivityPayload = formalizeActivityPayload;
                    ctrl.modifyRequisitionStates = (req, direction) => {
                        if (requisitionSPOC.currentStateName !== 'Delete' && requisitionSPOC.currentStateName !== 'Copy') {
                            $uibModalInstance.dismiss('cancel');
                            vm._modifyRequisitionStates(req, direction, refreshCardCallback);
                        }
                        else if (requisitionSPOC.currentStateName == 'Copy') {
                            vm.copyRequisition(req, () => {
                                copyCallback(req);
                                $uibModalInstance.dismiss('cancel');
                            });
                        }
                        else {
                            ctrl.isDeleteInProgress = true;
                            vm.deleteRequisition(req, () => {
                                if (deleteCallback) {
                                    deleteCallback();
                                }
                                $uibModalInstance.dismiss('cancel');
                            });
                        }
                    };
                    ctrl.closeModal = () => {
                        $uibModalInstance.dismiss('cancel');
                    };
                    ctrl.onInternalNoteChanged = () => {
                        ctrl.requisitionSPOC.externalNote = ctrl.requisitionSPOC.note;
                    };
                    ctrl.onExternalNoteChange = (event) => {
                        ctrl.requisitionSPOC.externalNote = event.externalNote;
                    };
                    ctrl.onCopyNoteChange = (event) => {
                        ctrl.copyNote = event.copyNote;
                    };
                    ctrl.receiveFormalizedComment = (event) => {
                        ctrl.requisitionSPOC.note = event;
                    };
                    ctrl.onVoiceTranscript = (transcript) => {
                        if (ctrl.requisitionSPOC.note) {
                            ctrl.requisitionSPOC.note += ' ' + transcript;
                        }
                        else {
                            ctrl.requisitionSPOC.note = transcript;
                        }
                    };
                }],
            controllerAs: 'requisitionAction',
            size: 'md',
            resolve: {
                requisitionSPOC: () => {
                    return requisitionSPOC;
                },
                MESSAGECONSTANTS: () => {
                    return vm.MESSAGECONSTANTS;
                },
                candidates: () => {
                    return candidates;
                },
                candidatesInLastStep: () => {
                    return candidatesInLastStep;
                },
                isSharedRequisition: () => {
                    return requisitionInfo.sharedRequisition;
                },
                formalizeActivityPayload: () => {
                    return requisitionInfo.formalizeActivityPayload;
                }
            }
        });
    }
    _modifyRequisitionStates(requisitionSPOC, direction, refreshCardCallback) {
        //Construct update status object
        let updateRequisitionObject = {};
        updateRequisitionObject.jobId = requisitionSPOC.RequisitionId;
        updateRequisitionObject.companyId = this.$rootScope.userDetails.company.companyId;
        if (requisitionSPOC.currentStateName === "Stop Sourcing") {
            updateRequisitionObject.jobStateType = "SOURCED";
        }
        else if (requisitionSPOC.currentStateName === "Fill") {
            updateRequisitionObject.jobStateType = "FILLED";
            updateRequisitionObject.fillDate = requisitionSPOC.candidateFillDate;
            updateRequisitionObject.expectedJoinDate = requisitionSPOC.candidateExpectedJoinDate;
            //updateRequisitionObject.candidateId = requisitionSPOC.candidate.id;
        }
        else if (requisitionSPOC.currentStateName === "Complete") {
            updateRequisitionObject.jobStateType = "COMPLETED";
        }
        else if (requisitionSPOC.currentStateName === "Cancel") {
            updateRequisitionObject.jobStateType = "CANCELED";
        }
        else if (requisitionSPOC.currentStateName === "Continue" || requisitionSPOC.currentStateName === "Reopen" || requisitionSPOC.currentStateName === "Resume Sourcing") {
            updateRequisitionObject.jobStateType = "OPEN";
        }
        else if (requisitionSPOC.currentStateName === "Pause") {
            updateRequisitionObject.jobStateType = "PAUSED";
        }
        else if (requisitionSPOC.currentStateName === "Delete") {
            updateRequisitionObject.jobStateType = "ARCHIVED";
        }
        else if (requisitionSPOC.currentStateName === "Join") {
            updateRequisitionObject.jobStateType = "JOINED";
            updateRequisitionObject.joinDate = requisitionSPOC.candidateJoinDate;
        }
        else {
            updateRequisitionObject.jobStateType = angular.uppercase(requisitionSPOC.requisitionStatus);
        }
        updateRequisitionObject.note = requisitionSPOC.note;
        updateRequisitionObject.externalNote = requisitionSPOC.externalNote;
        updateRequisitionObject.reasonCodeDTO = requisitionSPOC.reasonCodeDTO == undefined ? null : requisitionSPOC.reasonCodeDTO;
        updateRequisitionObject.updationDate = requisitionSPOC.date;
        updateRequisitionObject.updationTime = requisitionSPOC.time;
        updateRequisitionObject.requisitionActualNumber = requisitionSPOC.requisitionActualNumber;
        if (!angular.isUndefined(requisitionSPOC.candidate)) {
            if (requisitionSPOC.titleName === this.MESSAGECONSTANTS.VIEW_REQUISITION.REMOVE_FILLED_CANDIDATE) {
                updateRequisitionObject.candidateId = requisitionSPOC.candidate.fillCandidate.id;
            }
            else if (requisitionSPOC.titleName === this.MESSAGECONSTANTS.VIEW_REQUISITION.REMOVE_JOINED_CANDIDATE) {
                updateRequisitionObject.candidateId = requisitionSPOC.candidate.joinCandidate.id;
            }
            else {
                updateRequisitionObject.candidateId = requisitionSPOC.candidate.id;
            }
        }
        updateRequisitionObject.direction = direction;
        updateRequisitionObject.recruiterId = this.$rootScope.userDetails.id;
        if (direction === "Forward") {
            updateRequisitionObject.requisitionOpeningNumber = requisitionSPOC.requisitionOpeningNumber;
        }
        else if (direction === "Backward" && !angular.isUndefined(requisitionSPOC.candidate)) {
            updateRequisitionObject.requisitionOpeningNumber = requisitionSPOC.candidate.requisitionOpeningNumber;
        }
        //Call the API to update the status
        if (updateRequisitionObject.jobStateType !== "ARCHIVED") {
            this.genericService.addObject(this.StorageService.get('baseurl') + this.REQUISITIONSCONSTANTS.CONTROLLER.UPDATE_JOB_STATUS, updateRequisitionObject).subscribe((data) => {
                if (updateRequisitionObject.jobStateType == "OPEN") {
                    if (requisitionSPOC.currentStateName === "Reopen") {
                        updateRequisitionObject.jobStateType = "reopened";
                    }
                    else if (requisitionSPOC.currentStateName === "Resume Sourcing") {
                        updateRequisitionObject.jobStateType = "reopened for matching";
                    }
                    else {
                        updateRequisitionObject.jobStateType = "opened";
                    }
                }
                else if (requisitionSPOC.titleName === this.MESSAGECONSTANTS.VIEW_REQUISITION.REMOVE_FILLED_CANDIDATE || requisitionSPOC.titleName === this.MESSAGECONSTANTS.VIEW_REQUISITION.REMOVE_JOINED_CANDIDATE) {
                    updateRequisitionObject.jobStateType = "updated";
                }
                if (requisitionSPOC.currentStateName === "Reopen"
                    || requisitionSPOC.currentStateName === "Cancel"
                    || requisitionSPOC.currentStateName === "Complete") {
                    const title = requisitionSPOC.currentStateName + ' in progress.';
                    const message = `${requisitionSPOC.currentStateName} is in progress. You will be notified once the requisition is ${angular.lowercase(updateRequisitionObject.jobStateType)}.`;
                    this.alertsAndNotificationsService.showAlert(title, message, 'success');
                }
                else {
                    let successMessage = "Requisition '<b><i class='wrap-word'>(" + requisitionSPOC.requisitionActualNumber + ")</i></b>' " + angular.lowercase(updateRequisitionObject.jobStateType) + " successfully.";
                    this.alertsAndNotificationsService.showBannerMessage(successMessage, 'success');
                }
                // this.init(true);
                if (refreshCardCallback) {
                    refreshCardCallback();
                }
            }, (error) => {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            });
        }
        //     else {
        //         this.deleteRequisition(updateRequisitionObject);
        //   }
    }
    copyRequisition(requisition, copyCallback) {
        let requisitionObject = { id: requisition.RequisitionId, note: requisition.note };
        this.jobService.copyRequisition(requisitionObject.id, this.$rootScope.userDetails.company.companyId, (data) => {
            this.alertsAndNotificationsService.showBannerMessage("Requisition Copy Created Successfully", 'success');
            if (copyCallback) {
                copyCallback(data);
            }
        }, (error) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, "danger");
        });
    }
    deleteRequisition(requisition, deleteCallback) {
        let requisitionObject = { id: requisition.RequisitionId, note: requisition.note };
        this.jobService.deleteJob(requisitionObject, (data) => {
            this.alertsAndNotificationsService.showBannerMessage("Requisition '" + requisition.requisitionActualNumber + "' deleted successfully", 'success');
            if (deleteCallback) {
                deleteCallback();
            }
        }, (error) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, "danger");
        });
    }
    showBackwardActionModal(requisitionInfo, requisitionSPOC, candidates, refreshCardCallback) {
        let vm = this;
        this.$uibModal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            template: RequisitionBackwardActionModal.default,
            controller: ['$uibModalInstance', 'requisitionSPOC', 'MESSAGECONSTANTS', 'candidates', 'isSharedRequisition', 'reasonCodes', 'formalizeActivityPayload',
                function ($uibModalInstance, requisitionSPOC, MESSAGECONSTANTS, candidates, isSharedRequisition, reasonCodes, formalizeActivityPayload) {
                    let ctrl = this;
                    ctrl.requisitionSPOC = requisitionSPOC;
                    ctrl.MESSAGECONSTANTS = MESSAGECONSTANTS;
                    ctrl.candidates = candidates;
                    ctrl.isSharedRequisition = isSharedRequisition;
                    ctrl.externalNotesAction = {};
                    ctrl.reasonCodes = reasonCodes;
                    ctrl.disableSubmit = ctrl.requisitionSPOC.titleName === ctrl.MESSAGECONSTANTS.VIEW_REQUISITION.REMOVE_FILLED_CANDIDATE || ctrl.requisitionSPOC.titleName === ctrl.MESSAGECONSTANTS.VIEW_REQUISITION.REMOVE_JOINED_CANDIDATE;
                    ctrl.formalizeActivityPayload = formalizeActivityPayload;
                    ctrl.modifyRequisitionStates = (req, direction) => {
                        $uibModalInstance.dismiss('cancel');
                        vm._modifyRequisitionStates(req, direction, refreshCardCallback);
                    },
                        ctrl.closeModal = () => {
                            $uibModalInstance.dismiss('cancel');
                        };
                    ctrl.onInternalNoteChanged = () => {
                        ctrl.requisitionSPOC.externalNote = ctrl.requisitionSPOC.note;
                    };
                    ctrl.onExternalNoteChange = (event) => {
                        ctrl.requisitionSPOC.externalNote = event.externalNote;
                    };
                    ctrl.onCopyNoteChange = (event) => {
                        ctrl.copyNote = event.copyNote;
                    };
                    ctrl.receiveFormalizedComment = (event) => {
                        ctrl.requisitionSPOC.note = event;
                    };
                    ctrl.onVoiceTranscript = (transcript) => {
                        if (ctrl.requisitionSPOC.note) {
                            ctrl.requisitionSPOC.note += ' ' + transcript;
                        }
                        else {
                            ctrl.requisitionSPOC.note = transcript;
                        }
                    };
                    ctrl.onCandidateChange = () => {
                        if (ctrl.requisitionSPOC.candidate.canNotRemoveJoin && ctrl.requisitionSPOC.titleName === ctrl.MESSAGECONSTANTS.VIEW_REQUISITION.REMOVE_JOINED_CANDIDATE) {
                            ctrl.disableSubmit = true;
                            let title = 'Cannot undo join for the candidate';
                            let message = `This candidate is currently filled in Req # <b>${ctrl.requisitionSPOC.candidate.filledInRequisitionNumber}</b> with Title <b>${ctrl.requisitionSPOC.candidate.filledInRequisitionTitle}</b> at <b>${ctrl.requisitionSPOC.candidate.clientOrBuOfFilledOrJoinedRequisition}</b>. Please perform 'Undo Fill' action on the candidate for that Requisition before performing 'Undo Join' action in this Requisition.`;
                            vm.alertsAndNotificationsService.showAlert(title, message, 'warning');
                        }
                        else {
                            ctrl.disableSubmit = false;
                        }
                    };
                }],
            controllerAs: 'backwardAction',
            size: 'md',
            resolve: {
                requisitionSPOC: () => {
                    return requisitionSPOC;
                },
                MESSAGECONSTANTS: () => {
                    return vm.MESSAGECONSTANTS;
                },
                candidates: () => {
                    return candidates;
                },
                isSharedRequisition: () => {
                    return requisitionInfo.sharedRequisition;
                },
                reasonCodes: () => {
                    return vm.reasonCodes;
                },
                formalizeActivityPayload: () => {
                    return requisitionInfo.formalizeActivityPayload;
                }
            }
        });
    }
    showAllActivities(requisitionInfo) {
        let vm = this;
        this.$uibModal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            windowTopClass: 'four-dot-five-modal-medium',
            template: RequisitionActivityModal.default,
            controller: ['$uibModalInstance', 'jobId', 'role', 'requisitionNumber', 'clientName', 'isSharedRequisition', function ($uibModalInstance, jobId, role, requisitionNumber, clientName, isSharedRequisition) {
                    let ctrl = this;
                    ctrl.jobId = jobId;
                    ctrl.role = role;
                    ctrl.requisitionNumber = requisitionNumber;
                    ctrl.clientName = clientName;
                    ctrl.isSharedRequisition = isSharedRequisition;
                    ctrl.closeModal = () => {
                        $uibModalInstance.dismiss('cancel');
                    };
                }],
            controllerAs: 'activityModal',
            resolve: {
                jobId: () => {
                    return requisitionInfo.requisitionNumber;
                },
                role: () => {
                    return requisitionInfo.requisitionRole;
                },
                requisitionNumber: () => {
                    return requisitionInfo.requisitionActualNumber;
                },
                clientName: () => {
                    return requisitionInfo.companyName;
                },
                isSharedRequisition: () => {
                    return requisitionInfo.sharedRequisition;
                }
            }
        });
    }
}
//# sourceMappingURL=requisitionService.js.map